import { useRouter } from 'expo-router'
import { View } from 'react-native'
import { StyleSheet } from 'react-native-unistyles'

import Page from '@/components/shared/Page'
import UniButton from '@/components/unistyles/UniButton'
import UniText from '@/components/unistyles/UniText'

const Volunteer = () => {
  const router = useRouter()
  return (
    <Page requiresSubscription={false} viewId="welcome-volunteer">
      <View style={styles.container}>
        <View style={styles.content}>
          <View style={styles.headerContainer}>
            <UniText variant="headlineMedium">Thanks for volunteering!</UniText>
            <UniText style={styles.subtitle} variant="titleMedium">
              To get started with Rescuebase, you'll need an invitation from
              your rescue organization.
            </UniText>
          </View>

          <View style={styles.infoContainer}>
            <UniText style={styles.infoTitle} variant="titleMedium">
              Please ask your rescue coordinator to:
            </UniText>
            <View style={styles.listContainer}>
              <UniText style={styles.listItem} variant="bodyMedium">
                • Add you as a volunteer in Rescuebase
              </UniText>
              <UniText style={styles.listItem} variant="bodyMedium">
                • Send you an invitation to join their organization
              </UniText>
            </View>
          </View>

          <UniButton
            contentStyle={styles.buttonContent}
            mode="outlined"
            onPress={() => router.back()}
          >
            Go Back
          </UniButton>
        </View>
      </View>
    </Page>
  )
}

const styles = StyleSheet.create((theme) => ({
  buttonContent: {
    paddingVertical: theme.tokens.spacing[3],
  },
  container: {
    flex: 1,
    padding: theme.tokens.spacing[4],
    paddingBottom: theme.tokens.spacing[8],
  },
  content: {
    gap: theme.tokens.spacing[6],
  },
  headerContainer: {
    alignItems: 'center',
    gap: theme.tokens.spacing[2],
  },
  infoContainer: {
    backgroundColor: theme.colors.surfaceVariant,
    borderRadius: theme.tokens.containerBorderRadius,
    padding: theme.tokens.spacing[4],
  },
  infoTitle: {
    color: theme.colors.onSurfaceVariant,
    marginBottom: theme.tokens.spacing[2],
  },
  listContainer: {
    gap: theme.tokens.spacing[2],
  },
  listItem: {
    color: theme.colors.onSurfaceVariant,
  },
  subtitle: {
    color: theme.colors.onSurfaceVariant,
    textAlign: 'center',
  },
}))

export default Volunteer
